import React from 'react'
import ButtonLink from '@components/ButtonLink'
import { clickedFloaterButton } from '@components/FloaterBar/floaterButtonEvents'

const FloaterBarItem: React.FC<{ floaterItem: any }> = ({ floaterItem }) => {
  return floaterItem.buttonType === 'link' ? (
    <a
      href={floaterItem.link}
      className="cmp-floater-bar__item"
      rel={floaterItem.linkRelAttribute}
      aria-label={floaterItem.label}
      title={floaterItem.label}
    >
      <i className={floaterItem.icon} aria-hidden="true"></i>
    </a>
  ) : (
    <div className="cmp-floater-bar__item" title={floaterItem.label}>
      <ButtonLink
        onClick={() => clickedFloaterButton(floaterItem.applicationType)}
        text={''}
        icon={floaterItem.icon}
        ariaLabel={floaterItem.label}
      />
    </div>
  )
}
export default FloaterBarItem
